export class ILocationDetails {
    locationId: number;
    locationName: string;
    timeZoneName: string;
    address1: string;
    address2: string;
    address3: string;
    placeOfService: string;
    placeOfServiceDis: string;
    npi: string;
    fullAddress: string;
    state: string;
    stateCode: string;
    city: string;
    zip: string;
    zipExt: string;
    phone: string;
    phoneExtn: string;
    fax: string;
    startTime: Date;
    endTime: Date;
    zoneName: string;
    timeZoneIntervals: number;
    active: boolean;
    createdBy: string;
    createdOn: Date;
    modifiedBy: string;
    modifiedOn: Date;
    dbOpreation: string;
    spi: string;
    facilityId: string;
    start: string;
    end: string;
    facilityName: string;
    userId: string;
    userLocationId: number;
    selected: boolean;
    Isdisabled: boolean;
    IsSurgeryCenter?: boolean;
    slotTimeDuration: number;
    twillioPhoneNo: string;
    twillioVirtualPhoneNum: string;
    phiscalPhoneNum: string;
    isPhysicalPhoneEnable: boolean;
}
